import { useTypingStatusRotation } from '../../../hooks/useTypingStatusRotation.js'

/**
 * v1 parity: cycles Thinking / Searching / Typing labels with a slightly
 * random delay between each step (not tied to stream events).
 */
export function RotatingTypingStatus({ conf }) {
  const { currentStatus } = useTypingStatusRotation(conf)
  return <span className="text-sm">{currentStatus}</span>
}
